export default __webpack_public_path__ + "static/media/edit-icon-24px.39c04ecf.svg";